import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import OptionsButton from '../../../global/options-button/options-button';
import { MORE_BUTTON_TEXT } from '../../../../constants/common-labels.constants';
import { MANAGE_URL_TEXT, NEW_ORGANIZATION_TEXT } from '../../event-hubs.text';
import { hasPermission } from '../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../api/roles.dao';

type EventHubMoreButtonProps = {
    onManageUrl: () => void;
    onNewOrganization?: () => void;
};

export const EventHubMoreButton: React.FC<EventHubMoreButtonProps> = ({ onManageUrl, onNewOrganization }) => {
    const intl = useIntl();

    const moreButtonOptions = [
        hasPermission(Permission.MANAGE_HUB_SUBDOMAIN) && {
            label: intl.formatMessage(MANAGE_URL_TEXT),
            action: onManageUrl,
        },
        hasPermission(Permission.CREATE_HUB_ORGANIZATION) && onNewOrganization && {
            label: intl.formatMessage(NEW_ORGANIZATION_TEXT),
            action: onNewOrganization,
        }
    ].filter(Boolean);

    return moreButtonOptions.length ? (
        <OptionsButton
            options={moreButtonOptions}
            label={<FormattedMessage {...MORE_BUTTON_TEXT} />}
            modifier={['fat', 'options']}
            position='bottom'
            align='end'
        />
    ) : null;
};
